import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { useRef } from "react";
import Image from "next/image";
import { api } from "@/utils/Axios";
import axios from "axios";
import ar from "../../locales/common/ar";
import en from "../../locales/common/en";

export default function CustomFileInput({
  name,
  label,
  textHtmlFor,
  id,
  styles,
  setFieldValue,
  setFieldTouched,
  touched,
  setFieldError,
  errors,
  t,
  phone,
  setURL,
  clearFileName,
  setUpload,
  type,
  uploadType,
}) {
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [uploadSuccessful, setUploadSuccessful] = useState(false);
  const fileInputRef = useRef(null);
  useEffect(() => {
    if (clearFileName == true) {
      setFileName("");
    }
  }, [clearFileName]);

  useEffect(() => {
    if (phone && !uploadSuccessful) {
      setError("");
    }

    if (!phone && touched[name] && !uploadSuccessful) {
      setError(t.form_labels.enterPhoneFirst);
      return;
    }

    if (errors.mobilePhone && !uploadSuccessful && touched[name]) {
      if (
        errors.mobilePhone === "Required" ||
        errors.mobilePhone === "اجباري"
      ) {
        setError(t.form_labels.enterPhoneFirst);
        return;
      }
    }

    if (errors[name] && touched[name] && !uploadSuccessful) {
      setError(errors[name]);
    }
  }, [
    phone,
    touched[name],
    errors.mobilePhone,
    errors[name],
    name,
    uploadSuccessful,
    t.form_labels.enterPhoneFirst,
  ]);

  const handleFileChange = async (event) => {
    setUploadSuccessful(false);
    if (!phone) {
      setError(t.form_labels.enterPhoneFirst);
      setFieldTouched(name, true);
      event.target.value = null;
      return;
    }
    if (!phone && touched[name]) {
      setError(t.form_labels.enterPhoneFirst);
      // setError("");
    }

    if (event.target && event.target.files) {
      const file = event.target.files[0];
      setFieldTouched(name, true, false);
      setFieldValue(name, file, false);
      const validFileType = (file) => {
        return (
          file?.type === "application/pdf" || file?.type.startsWith("image/")
        );
      };
      if (
        file?.size <= 5 * 1024 * 1024 &&
        !errors.mobilePhone &&
        (phone || !!errors.mobilePhone) &&
        validFileType(file)
      ) {
        try {
          setLoading(true);
          setUpload?.(false);
          const res = await api.post(`/s3/public/generate-presigned-url`, {
            phone: uploadType ? `+2${phone}` : `+971${phone}`,
            imageType: uploadType || name,
          });
          if (res.data && res.data.uploadUrl) {
            await axios.put(`${res.data.uploadUrl}`, file, {
              headers: {
                "Content-Type": file?.type,
                "Content-Encoding": "base64",
              },
            });
            setURL(res.data.fileUrl);
            setFileName(file ? file.name : "");
            setLoading(false);
            setUpload?.(true);
            setError("");
            setUploadSuccessful(true);
          } else {
            setLoading(false);
            setUpload?.(true);
            setUploadSuccessful(false);
            if (!navigator.onLine) {
              setError(t.connectionError);
            }
            if (!phone || !!errors.mobilePhone) {
              setError(t.form_labels.enterPhoneFirst);
            } else {
              setError(t.Erroruploadingfile);
            }
          }
        } catch (error) {
          if (!phone || !!errors.mobilePhone) {
            setError(t.form_labels.enterPhoneFirst);
          }
          setUploadSuccessful(false);
          setLoading(false);
          setUpload?.(true);
          if (!navigator.onLine) {
            setError(t.connectionError);
          } else {
            setError(t.Erroruploadingfile);
          }
        }
      }
    } else {
      setLoading(false);
      setUpload?.(true);
      if (!phone || !!errors.mobilePhone) {
        setError(t.form_labels.enterPhoneFirst);
      }
      console.error("No files selected or event target is invalid");
    }

    event.target.value = null;
  };

  const handleTextFieldClick = () => {
    if (
      (!errors.mobilePhone ||
        errors.mobilePhone == "Required" ||
        errors.mobilePhone == "اجباري") &&
      error !== t.form_labels.enterPhoneFirst
    ) {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    }
  };

  return (
    <Box
      sx={styles.inputWrapper}
      style={{
        width: type === "uae" || uploadType === "careers" ? "100%" : "250px",
      }}
    >
      <InputLabel htmlFor={textHtmlFor}>
        <Box sx={{ display: "flex" }}>
          <Typography sx={styles.label}>{label}</Typography>
          {(name == "workPermitUrl" ||
            name == "hrLetter" ||
            name == "bankStatementUrl") && (
            <span
              style={{
                fontWeight: 400,
                fontSize: "12px",
                padding: "1.5px",
                marginLeft: t === en ? "2px" : 0,
                marginRight: t === ar ? "2px" : 0,
                color: "#2D317F",
              }}
            >{`(${t.form_labels.optional})`}</span>
          )}
        </Box>
      </InputLabel>
      <TextField
        disabled={!!errors.mobilePhone && touched[name]}
        variant="outlined"
        id={id}
        value={loading || error || !phone ? "" : fileName}
        error={touched[name] && errors[name]}
        onClick={handleTextFieldClick}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Button
                disabled={!!errors.mobilePhone && touched[name]}
                variant="outlined"
                component="label"
                sx={{
                  color: " #545A62",
                  border: "1px solid #545A62",
                  padding: " 4px 16px",
                  gap: "10px",
                  borderRadius: "6px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {t.form_labels.chooseFile}
                <Image
                  quality={100}
                  src="/upload-cloud.svg"
                  width={16}
                  height={16}
                  alt="upload-cloud-icon"
                />
              </Button>
            </InputAdornment>
          ),
          endAdornment: loading ? (
            <InputAdornment position="end">
              <CircularProgress size={20} sx={{ color: "#545A62" }} />
            </InputAdornment>
          ) : null,
          readOnly: true,
        }}
        sx={{
          ...styles.input,
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: touched[name] && error ? "#C12D10" : "grey",
            },
            "&:hover fieldset": {
              borderColor: touched[name] && error ? "#C12D10" : "grey",
            },
            "&.Mui-focused fieldset": {
              borderColor: touched[name] && error ? "#C12D10" : "grey",
            },
          },
          cursor: errors.mobilePhone ? "not-allowed" : "pointer",
        }}
      />

      <input
        type="file"
        style={{ display: "none" }}
        id={name}
        ref={fileInputRef}
        name={name}
        accept=".pdf,image/*"
        onChange={handleFileChange}
      />
      {touched[name] && error && (
        <Typography
          color="error"
          sx={{
            color: "#d32f2f",
            fontSize: "0.75rem",
            m: 0.5,
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
}
